import { http } from "../base"


export async function getMessagesByTenant(params = {}) {
  console.log("getMessagesByTenant", params);
  try {
    const response = await http.get(
      '/aics/message/list',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("查询站内信列表失败:", error);
    throw error;
  }
}

/**
 * 获取群发消息列表（支持搜索）
 */
export async function getBatchMessagesByTenant(params = {}) {
  try {
    // params 对象中已经包含 keyword 属性
    const response = await http.get('/aics/message/batchlist', { params });
    return response.data;
  } catch (error) {
    console.error("查询站内信列表失败:", error);
    throw error;
  }
}
// 新增API方法
export async function getUnreadCount() {
  try {
    const response = await http.get('/aics/message/unread-count');
    return response.data;
  } catch (error) {
    console.error("获取未读数量失败:", error);
    throw error;
  }
}

export async function getMessageDetail(id) {
  try {
    const response = await http.get(`/aics/message/${id}`);
    return response.data;
  } catch (error) {
    console.error("获取消息详情失败:", error);
    throw error;
  }
}

export async function markAsRead(id) {
  try {
    console.log("markAsRead", id);
    const response = await http.put(`/aics/message/${id}/read`);
    return response.data;
  } catch (error) {
    console.error("标记已读失败:", error);
    throw error;
  }
}

export async function batchMarkAsRead(ids) {
  try {
    const response = await http.put('/aics/message/batch-read', ids);
    return response.data;
  } catch (error) {
    console.error("批量标记已读失败:", error);
    throw error;
  }
}

export async function deleteMessage(id) {
  try {
    const response = await http.delete(`/aics/message/${id}`);
    return response.data;
  } catch (error) {
    console.error("删除消息失败:", error);
    throw error;
  }
}

export async function batchDeleteMessages(ids) {
  try {
    const response = await http.delete('/aics/message/batch', { data: ids });
    return response.data;
  } catch (error) {
    console.error("批量删除失败:", error);
    throw error;
  }
}

// 发送消息
export function sendMessage(data) {
  console.log('📤 [sendMessage] 即将发送请求，data:', data);
  // 查看axios实例的默认头
  console.log('📤 [sendMessage] http.defaults.headers:', http.defaults.headers);
  return http.post('/aics/message/send', data)
    .then(response => {
      console.log('✅ [sendMessage] 成功:', response);
      return response;
    })
    .catch(error => {
      console.error('❌ [sendMessage] 失败:', error);
      throw error;
    });
}